import { tokenService } from './tokenService';
import { AuthState } from '../../types/auth';

/**
 * Verifica se existe um token JWT válido armazenado (cookies/local storage)
 */
export function hasValidToken(): boolean {
  try {
    const accessToken = tokenService.getAccessToken();
    if (!accessToken) return false;
    return !tokenService.isTokenExpired(accessToken);
  } catch {
    return false;
  }
}

/**
 * Retorna se há assinatura ativa a partir do estado de auth
 */
export function hasActiveSubscription(authState: AuthState): boolean {
  return Boolean(authState?.hasActivePlan);
}

/**
 * Retorna se o perfil está completo a partir do estado de auth
 */
export function isProfileComplete(authState: AuthState): boolean {
  return Boolean(authState?.hasCompleteProfile);
}

export default {
  hasValidToken,
  hasActiveSubscription,
  isProfileComplete,
};